import React, { useRef, useState } from "react";
import AppLayout, {
  AppLayoutProps,
} from "@amzn/awsui-components-console/app-layout";
import { NonCancelableCustomEvent } from "@amzn/awsui-components-console";
import { Navigation } from "src/pages/commons";
import { URLS } from "src/components/constants/appConstants";
import { ToolsContent } from "./components/common-components";
import "../commons/common.styles.scss";
import { appLayoutAriaLabels } from "src/i18n-strings/app-layout";
import { AppAllFixedFeeConfigs } from "src/components/allFixedFeeConfigsPage/all-fixed-fee-configs-page";

export function AllFixedFeeConfigs() {
  const [navigationOpen, setNavigationOpen] = React.useState(false);
  const appLayout = useRef<AppLayoutProps.Ref>(null);
  const [toolsOpen, setToolsOpen] = useState(false);

  const onToolsChangeFn = ({
    detail,
  }: NonCancelableCustomEvent<AppLayoutProps.ChangeDetail>) => {
    setToolsOpen(detail.open);
  };
  return (
    <AppLayout
      disableContentPaddings
      content={<AppAllFixedFeeConfigs />}
      navigation={<Navigation activeHref={URLS.LIST_ALL_FIXED_FEE_CONFIGS} />}
      navigationOpen={navigationOpen}
      onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
      tools={<ToolsContent />}
      toolsOpen={toolsOpen}
      onToolsChange={onToolsChangeFn}
      ariaLabels={appLayoutAriaLabels}
    />
  );
}
